import clsx from 'clsx';
import React from 'react';

export function Subtitle(props: React.HTMLAttributes<HTMLParagraphElement>) {
	return <p className={clsx('text-gray-600', props.className)} {...props} />;
}
